<template>
    <div>
        <div class="prompt-heading">{{ 'Prompt Modifier' | trans }}</div>
        <div class="prompt-container">
            <div v-for="(option, index) in this.creatorStudio.settings.prompt_modifier" :key="index">
                <delete-prompt :prompt="option"></delete-prompt>
            </div>
        </div>
    </div>
</template>
<script>
import DeletePrompt from './Elements/DeletePrompt.vue';
import store from '../../mixins/store.mixin';
export default {
    name: 'PromptModifier',
    mixins: [store],
    components: {
        DeletePrompt,
    },
    computed: {},
};
</script>
<style scoped>
.prompt-container {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
}
.prompt-heading {
    margin-bottom: 10px;
}
</style>
